import { Form, useFormikContext } from 'formik'
import { FieldSet, ActionLink } from 'app/_shared'
import Error from '../Error'

export default ({editable, children}) => {
  const { isSubmitting } = useFormikContext();
  return (
    <Form>
      {children}
      <FieldSet type="email" name="email" label="Email address" disabled={editable} />
      <Error />
      <ActionLink type="submit" appearance="button" disabled={isSubmitting}>Send code</ActionLink>
    </Form>
  )
}
